import cn from 'classnames';
import { useHistory } from '@medlinker/fundamental';
import React, { ReactNode, useCallback, useMemo, useState } from 'react';

import CityPicker from '../Picker/CityPicker';
import useDidMount from '../../hooks/useDidMount';
import useHashQuery from '../../hooks/useHashQuery';
import { getAddressByIP } from '../../utils/lbsHelper';
import LocationModal from './LocationModal';
import { LocationInfo } from './types';
import { defaultLocation } from './constant';

import styles from './index.module.scss';

interface Props {
  manualable?: boolean;
  openPickerWithHistory?: boolean;
  left?: ReactNode;
  right?: ReactNode;
  className?: string;
  cityModalClassNames?: string;
  cityBodyClassNames?: string;
  onLocation?(info: LocationInfo): void;
}

const Location = ({
  manualable,
  openPickerWithHistory,
  left,
  right,
  className,
  cityModalClassNames,
  cityBodyClassNames,
  onLocation,
}: Props) => {
  const { query, setQuery } = useHashQuery();

  const [selected, setSelected] = useState<LocationInfo>();
  const [showCityPicker, setShowCityPicker] = useState(false);

  const [modalInfo, setModalInfo] = useState<any>({
    visible: false,
    cancelText: '取消',
    okText: '确定',
  });

  const cityPickerValue = useMemo(() => {
    if (!selected) return ['', '', ''] as [string, string, string];

    return [selected.province, selected.city, selected.area] as [
      string,
      string,
      string
    ];
  }, [selected]);

  const setLocationValue = useCallback(
    (info: LocationInfo) => {
      setSelected(info);
      onLocation?.(info);
    },
    [onLocation]
  );

  const getLocationInfo = useCallback(async () => {
    try {
      const res = await getAddressByIP();

      console.log(res);

      setLocationValue({
        latitude: res.location.lat,
        longitude: res.location.lng,
        province: res.ad_info.province,
        city: res.ad_info.city,
        area: res.ad_info.district,
      });
    } catch (e) {
      setModalInfo({
        ...modalInfo,
        visible: true,
        tips: '获取位置失败，为您展示默认信息',
        okText: '我知道了',
        hideCancel: true,
        onOk: () => {
          setLocationValue(defaultLocation);
          setModalInfo({ ...modalInfo, visible: false });
        },
      });
    }
  }, [modalInfo, setLocationValue]);

  useDidMount(() => {
    // 只进行一次提示
    const KEY = '_local_agree_location_auth';
    const isAgreed = localStorage.getItem(KEY);

    if (isAgreed) return getLocationInfo();

    setModalInfo({
      ...modalInfo,
      visible: true,
      tips: '系统将访问您的位置权限',
      okText: '允许',
      cancelText: '拒绝',
      onOk: () => {
        localStorage.setItem(KEY, '1');
        getLocationInfo();
        setModalInfo({ ...modalInfo, visible: false });
      },
      onCancel: () => {
        setLocationValue(defaultLocation);
        setModalInfo({ ...modalInfo, visible: false });
      },
    });
  });

  const history = useHistory();
  const handleShowCityPicker = () => {
    if (!manualable) return;

    if (openPickerWithHistory) {
      setQuery('chooseCity', 1);
    } else setShowCityPicker(true);
  };

  const handleHideCityPicker = () => {
    if (openPickerWithHistory && query.chooseCity) {
      history.goBack();
    } else setShowCityPicker(false);
  };

  return (
    <>
      <div
        className={cn(styles.cityInfo, className)}
        onClick={() => handleShowCityPicker()}
      >
        {left}
        <span>
          {selected?.city}
          {selected?.area}
        </span>
        {right ||
          (manualable && (
            <img src={require('./images/arrow.png')} alt="logo" />
          ))}
      </div>
      <LocationModal {...modalInfo} />
      {manualable && (
        <CityPicker
          open={showCityPicker || !!query.chooseCity}
          value={cityPickerValue}
          bodyClassNames={cityBodyClassNames}
          modalClassNames={cityModalClassNames}
          onClose={() => {
            handleHideCityPicker();
          }}
          onChange={res => {
            const { province, city, district, location } = res;

            setLocationValue({
              latitude: location.lat,
              longitude: location.lng,
              province,
              city,
              area: district,
            });
            handleHideCityPicker();
          }}
        />
      )}
    </>
  );
};

export default React.memo(Location);
